import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";


interface BreadcrumbClickedPayload {
    level: String,
}

export class BreadcrumbClickedEvent implements WhitelabelEventWithPayload<BreadcrumbClickedPayload> {
    type: string;
    payload: BreadcrumbClickedPayload;
    static readonly TYPE: string = 'breadcrumb-clicked'

    constructor(payload: BreadcrumbClickedPayload) {
        this.type = BreadcrumbClickedEvent.TYPE
        this.payload = payload;
    }
}